import React from 'react';
import type { ColDef } from 'ag-grid-community';
import { LopCrudPage } from '../../components/LopCrudPage';
import { getNonDmf4Fund, saveNonDmf4FundBatch } from '../../api/nonDays';
import type { NonDmf4Fund } from '../../types/NonDays';
import { dateColumnProps } from '../../utils/dateColumn';
import { t } from '../../i18n/t';

const columnDefs: ColDef<NonDmf4Fund>[] = [
  {
    field: 'recId',
    headerName: t('nonDmf4Fund.columns.recId'),
    width: 110,
    editable: false,
    cellDataType: 'number',
  },
  {
    field: 'dDate',
    headerName: t('nonDmf4Fund.columns.dDate'),
    width: 160,
    editable: true,
    sort: 'desc',
    ...dateColumnProps<NonDmf4Fund>('dDate'),
  },
  {
    field: 'fundId',
    headerName: t('nonDmf4Fund.columns.fundId'),
    width: 120,
    editable: true,
    cellDataType: 'number',
  },
  {
    field: 'reason',
    headerName: t('nonDmf4Fund.columns.reason'),
    flex: 1,
    minWidth: 240,
    editable: true,
  },
];

const newDefaults = (): Partial<NonDmf4Fund> => ({
  recId: 0,
  dDate: null as unknown as string,
  fundId: 0,
  reason: '',
});

export function NonDmf4FundPage() {
  return (
    <LopCrudPage<NonDmf4Fund>
      resourceCode="nonDmf4Fund"
      titleKey="nonDmf4Fund.pageTitle"
      idField="recId"
      getRows={getNonDmf4Fund}
      saveBatch={(added, modified, deletedIds) =>
        saveNonDmf4FundBatch(added, modified, deletedIds as number[])
      }
      columnDefs={columnDefs}
      newRowDefaults={newDefaults}
    />
  );
}
